import { type SelectionEvent } from '../events/types';
import { type SelectionState } from '../state/types';

import { extendToCellReducer } from './extend-to-cell';
import { selectCellReducer } from './select-cell';
import { type Reducer } from './types';

/**
 * Main reducer that routes events to their specific reducers. Add new reducers
 * here as you create them. Returns noop for unhandled events.
 */
export const selectionsReducer: Reducer = (
  prev: SelectionState,
  event: SelectionEvent
) => {
  if (event.type === 'selectCell') {
    return selectCellReducer(prev, event);
  }

  if (event.type === 'extendToCell') {
    return extendToCellReducer(prev, event);
  }

  return { next: prev, delta: { kind: 'noop' } };
};
